module.exports = __webpack_public_path__ + "static/media/water-droplet.57f45b49.svg";